import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=1a32a7c1&scoped=true&"
import script from "./TextToSpeech.vue?vue&type=script&lang=js&"
export * from "./TextToSpeech.vue?vue&type=script&lang=js&"
import style0 from "./TextToSpeech.vue?vue&type=style&index=0&id=1a32a7c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32a7c1",
  null
  
)

/* custom blocks */
import block0 from "./TextToSpeech.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports